import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { Developments } from "@/pages/Developments/Developments";
import { DevelopmentDetail } from "@/pages/Developments/DevelopmentDetail";

const LIST_PATH_PATTERN = /^(?:open|closed|all)?$/;
const DETAIL_PATH_PATTERN = /^\d+$/;

export const DevelopmentRoutes: React.FC = () => {
    const path = useParams()["*"] ?? "";

    if (LIST_PATH_PATTERN.test(path)) {
        return <Developments />;
    }

    if (DETAIL_PATH_PATTERN.test(path)) {
        return <DevelopmentDetail developmentId={path} />;
    }

    return <Navigate to="/developments" replace />;
};

export { Developments, DevelopmentDetail };
